import React, { useEffect, useRef } from 'react';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import './SearchBar.css';

const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN || 'pk.eyJ1IjoidG9yZ3lkIiwiYSI6ImNtNXN6ZGQ0bjBhbGIya3M5dHpwY2p3aDkifQ.placeholder';

const SearchBar = ({ onResultSelect }) => {
  const geocoderContainerRef = useRef(null);
  const geocoderRef = useRef(null);

  useEffect(() => {
    if (!geocoderContainerRef.current) return;

    // Initialize Mapbox Geocoder
    const geocoder = new MapboxGeocoder({
      accessToken: MAPBOX_TOKEN,
      types: 'place,locality,region', // Cities only
      placeholder: 'Search for a city...',
      marker: false, // Don't add default marker
      flyTo: false, // We'll handle map navigation manually
      bbox: [-180, -90, 180, 90], // Global search
      limit: 5, // Show top 5 results
      language: 'en', // English results
      autocomplete: true,
      minLength: 2, // Start searching after 2 characters
    });

    // Add geocoder to the container
    geocoderContainerRef.current.appendChild(geocoder.onAdd());
    geocoderRef.current = geocoder;

    // Handle result selection
    geocoder.on('result', (e) => {
      const { result } = e;

      // Extract coordinates
      const [longitude, latitude] = result.center;
      const cityName = result.place_name;

      // Call parent callback with city data
      if (onResultSelect) {
        onResultSelect({
          longitude,
          latitude,
          cityName,
          bbox: result.bbox, // Bounding box for the city (optional)
        });
      }

      // Clear the search input after selection
      setTimeout(() => {
        geocoder.clear();
      }, 100);
    });

    // Cleanup on unmount
    return () => {
      if (geocoderRef.current) {
        geocoderRef.current.onRemove();
      }
    };
  }, [onResultSelect]);

  return (
    <div className="search-bar-container">
      <div ref={geocoderContainerRef} className="geocoder-wrapper"></div>
    </div>
  );
};

export default SearchBar;
